import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileDoneOutlinedSvg from "@ant-design/icons-svg/es/asn/FileDoneOutlined";
import AntdIcon from "../components/AntdIcon";
var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileDoneOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileDoneOutlined.displayName = 'FileDoneOutlined';
}
export default /*#__PURE__*/React.forwardRef(FileDoneOutlined);